<template>
	<!-- <div class="account-msisdn"> -->
	<!-- MSISDN NUMBER INFO -->
	<!-- <div class="box-account-info"> -->
	<!-- <table> -->
	<!-- <thead>
					<th>Alias</th>
					<th>Número</th>
					<th>Plan</th>
					<th>Costo</th>
				</thead> -->
	<tr class="account-msisdn">
		<td> {{ numero.alias }} </td>
		<td> {{ msisdn | msisdnToPhone }} </td>
		<template v-if="numero.planName">
			<td> {{ numero.planName }} </td>
			<td> {{ numero.estatus_suscripcion }} </td>
			<td> {{ numero.precio | currency }} </td>
		</template>
		<template v-else>
			<td cols="3"> Sin oferta </td>
		</template>
	</tr>
	<!-- </table> -->
	<!-- </div> -->
	<!-- </div> -->
</template>

<script>

export default {
	name: 'accountSaldoPage',
	props: {
		debug: {
			type: Boolean,
			default: false
		},
		msisdn: {
			type: [String, Number],
			required: true
		},
		numero: {
			type: Object,
			required: true
		}
	},
	data: () => {
		return {
			isLoading: false,
		}
	}
}
</script>

<style lang="less">
.account-msisdn {

	td {
		background-color: lightblue;
		text-align: center;
	}

	&+.account-msisdn {
		margin-top: 3em;
	}

	.box-tab-1 .box-bar {



		.col-title {
			text-align: left;
			margin-left: 12.5em;
		}
	}

}

</style>